import { logger } from '../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../utils/dom'
import { IdentityScreen } from '../../../enums'
import { LoginService } from '../services/login-service'
import { LoginRadiusWidget, LRWidgetType } from './base'

export class EmailValidationWidget extends LoginRadiusWidget {

    private validateEmailOptions = {
        onError: this.onError,
        onSuccess: this.onSuccess,
    }

    constructor(container: string, lrObject: any) {
        super()
        this.widgetType = LRWidgetType.VERIFY_EMAIL
        this.lrObject = lrObject
        this.container = container
        logger('info','Email validation widget created')
    }

    public initEmailValidation() {
        if (document.querySelector(`#${this.container}`)) {
            logger('info','Initializing Email validation widget')
            this.lrObject.init('verifyEmail', this.validateEmailOptions)
            logger('info','Email validation widget initialized')
        }
    }

    public onSuccess(response: any) {
        logger('info', response)

        // Success page
        DOMUtils.addClass(document.body, IdentityScreen.SUCCESS)
    }

    public onError(errors: any) {
        const LINK_ALREADY_USED = 974
        const isAlreadyUsed = !!(errors.length && errors[0].ErrorCode === LINK_ALREADY_USED)

        LoginService.showErrors(errors)
        DOMUtils.addClass(document.body, IdentityScreen.ERROR)
        logger('error', errors)
        LoginService.sendSubmissionErrorAnalytics(errors, 'email-validation')

        let msg = 'The email verification link is no longer valid.'
        if (isAlreadyUsed) {
            msg = 'The email verification link has already been used.'
        }
        location.replace(`/verify-email/?msg=${msg}`)
    }
}
